import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import { z } from 'zod'
import { useGetRawCartById } from 'services/checkout/useGetCartById'
import { CartContext } from './Hook/CartContext'

const QuerySchema = z.object({
  cartId: z.string(),
  redirect_status: z.string().optional()
})

export const TrackingScript = () => {
  const router = useRouter()
  const [cartId, setCartId] = useState<string>()
  const cart = useContext(CartContext)

  useEffect(() => {
    const queryParseResult = QuerySchema.safeParse(router.query)
    if (
      queryParseResult.success &&
      queryParseResult.data.redirect_status !== 'failed'
    ) {
      setCartId(queryParseResult.data.cartId)
    }
  }, [router.isReady, router.query])
  const cartQuery = useGetRawCartById(cartId, {
    focusThrottleInterval: 24 * 60 * 60 * 1000
  })

  const finalCart = cartQuery.data || cart?.cart

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      '_quantiTag' in window &&
      typeof window._quantiTag === 'function' &&
      router.isReady &&
      !router.pathname.startsWith('/preview')
    ) {
      window._quantiTag('hit', 'page_view', {
        page_url: window.location.href,
        user_id: finalCart?.customer_id || '',
        conversion_id: finalCart?.id || '',
        conversion_value: undefined,
        conversion_type: '',
        consent: '',
        product_ids: ''
      })
    }
  }, [router.isReady, finalCart?.id])
  return null
}
